export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
  { code: 'pt', label: 'Português', dir: 'ltr' },
  { code: 'es', label: 'Español', dir: 'ltr' },
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]['code'];

export const RTL_LOCALES: readonly string[] = ['ar', 'he'];

export const DEFAULT_NAMESPACES = [
  'common',
  'auth',
  'agents',
  'chat',
  'settings',
  'errors',
] as const;
